import React from "react"
import { Fields, Form2 } from "@cd2/forms"
import { IComponentProp } from "@cd2/tools"

export const hrRegions = [
  { label: "England", value: "England" },
  { label: "Scotland", value: "Scotland" },
  { label: "Wales", value: "Wales" },
  { label: "Ireland", value: "Ireland" },
  { label: "Northern Ireland", value: "Northern Ireland" },
] as const
export function HrRegionSelect({
  label,
  field,
  validations,
  isClearable,
}: {
  label?: string
  field?: string
  validations?: IComponentProp<typeof Form2.Select, "validations">
  isClearable?: boolean
}) {
  return (
    <Form2.Select
      field={field ?? "hrRegion"}
      label={label ?? "HR Region"}
      options={hrRegions}
      valueExtractor={(opt: { value: string }) => opt.value}
      validations={validations}
      isClearable={isClearable}
    />
  )
}

export function HrRegionSelectField({
  label,
  onChange,
  value,
  isClearable,
}: {
  label?: string
  onChange: (region: string) => void
  value?: string
  isClearable?: boolean
}) {
  return (
    <Fields.Select2
      label={label}
      options={hrRegions}
      onChange={value => onChange(value?.value)}
      value={value ? hrRegions.find(r => r.value === value) : undefined}
      isClearable={isClearable}
    />
  )
}
